module.exports = __webpack_public_path__ + "media/images/lave linge-30269e6ed5185e06d21b7b7b28defe70.svg";